import ShogunStampHistoryForm from './ShogunStampHistoryForm';

export default ShogunStampHistoryForm;
